import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Route, Router, Routes } from '@angular/router';
import { ApiService } from '../shared/services/apiService.service';
import { filter } from 'rxjs/operators';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
import { RootService } from '../shared/services/root.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  // host: {'window:beforeunload':'doSomething'},
  // styleUrls: ['./quotation.component.scss']
})
export class QuotationComponent implements OnInit {
url:any;
quote_id:any='';
opty_id=''
userLogIn:any;
  constructor(private route: ActivatedRoute,private apiservice:ApiService,private router: Router,private behaviour :BehaviourSubjectService,  private storageService: RootService,private renderer: Renderer2, @Inject(PLATFORM_ID) private platformId: Object
){
    // window.open("about:blank", "_self");
    // // alert("hello")
    // window.close();

  }
@ViewChild('link') link !:ElementRef<HTMLAnchorElement>
  ngOnInit(): void {

    // this.route.paramMap.subscribe((params )=>{
    //   this.quote_id=params.get('quotationType');
    // })
    this.route.queryParams.subscribe(queryParams => {
          let id = (Object.keys(queryParams));
           this.quote_id=id[0]
          });

    this.userLogIn=this.storageService.isLoggedIn() ? true : false;
    this.getQuatationdata();
  }
  getQuatationdata(){
    if (isPlatformBrowser(this.platformId)) {
    let data={
      "quote_id":this.quote_id
    }
    this.apiservice.getQuotation(data).subscribe(({
      next: (res: any) => {
      window.open(res.data.file_path[0],'_blank')
      window.close();
      this.router.navigate(['/login'])
      },
      error: () => {
          this.router.navigate(['/login'])
        // }

       },
      complete: () => { }
    }))
  }
  }

}
